import moment from "moment";
import "moment/locale/zh-cn";
import {
  detailBySchoolNo,
  listBySchoolNo,
  doCard
} from '@/api/api.js'

export default {
  data() {
    return {
      schoolNo: '',
      scoolName: '',
      classUpdateFrequency: 0,  // 数据更新时间间隔(秒)
      currentTime: {
        date: '',
        week: '',
        time: '',
      },
      footerArr: [{
          class: "redC",
          text: "未放学"
        },
        {
          class: "purpleC",
          text: "放学中"
        },
        {
          class: "greenC",
          text: "已放学"
        },
      ],
      weifxArr: [], // 未放学
      fxzhongArr: [], // 放学中
      yifxArr: [], // 已放学

      weifxArrAll: [], // 未放学_all
      fxzhongArrAll: [], // 放学中_all
      yifxArrAll: [], // 已放学_all

      totalNum: 0, // 总的班级数量
      noticeText: '', // 通知文本

      isSpread0: false, //未放学_是否展开
      isSpread1: false, //放学中_是否展开
      isSpread2: false, //已放学_是否展开

      myInterval: '', // 定时器

      isShowCaret: [false, false, false],  // 是否显示下拉三角
      initItemBoxHeight: 0, // 初始化itemBox高度
      // 需要用到的dom集合
      doms:{
        titleDom: null,
        itemBox0Dom: null,
        itemBox1Dom: null,
        itemBox2Dom: null,
        content0Dom: null,
        content1Dom: null,
        content2Dom: null,
      }
    };
  },
  methods: {
    // 获取学校详情
    async getDetailBySchoolNo() {
      return detailBySchoolNo({
        schoolNo: this.schoolNo
      }).then(res => {
        this.scoolName = res.data.schoolName
        this.classUpdateFrequency = res.data.classUpdateFrequency
      })
    },
    // 获取班级列表
    getListBySchoolNo() {
      return listBySchoolNo({
        schoolNo: this.schoolNo
      }).then(res => {
        this.weifxArrAll = res.data.filter(item => item.leaveStatus == 0)
        this.fxzhongArrAll = res.data.filter(item => item.leaveStatus == 1)
        this.yifxArrAll = res.data.filter(item => item.leaveStatus == 2)

        this.weifxArr = [...this.weifxArrAll]
        this.fxzhongArr = [...this.fxzhongArrAll]
        this.yifxArr = [...this.yifxArrAll]

        this.totalNum = res.data.length
        this.changeNotice()
        this.isShowRightCaret()
      })
    },

    doCard(cardNo) {
      doCard({
        cardNo: cardNo
      }).then(async res => {
        if (res.code == 200) {
          await this.getListBySchoolNo()
        } else {
          this.$message.error(res.message);
        }
      })
    },

    // 改变通知信息
    changeNotice() {
      if (this.weifxArrAll.length == this.totalNum) {
        this.noticeText = "现在还未放学，请家长耐心等待！"
      } else if (this.yifxArrAll.length == this.totalNum) {
        this.noticeText = "放学结束，所有班级正常离校，祝大家一路顺风！"
      } else {
        this.noticeText = "现在正在放学，请家长保持门口道路通畅！"
      }
    },

    // 展开
    spread(type) {
      switch (type) {
        case 0:
          this.isSpread0 = true
          this.doms.itemBox0Dom.style.height = this.doms.content0Dom.scrollHeight + this.doms.titleDom.offsetHeight + 'px'
          break;
        case 1:
          this.isSpread1 = true
          this.doms.itemBox1Dom.style.height = this.doms.content1Dom.scrollHeight + this.doms.titleDom.offsetHeight + 'px'
          break;
        case 2:
          this.isSpread2 = true
          this.doms.itemBox2Dom.style.height = this.doms.content2Dom.scrollHeight + this.doms.titleDom.offsetHeight + 'px'
          break;
        default:
          break;
      }
    },

    // 折叠
    fold(type) {
      switch (type) {
        case 0:
          this.isSpread0 = false
          this.doms.itemBox0Dom.style.height = this.initItemBoxHeight + 'px'
          break;
        case 1:
          this.isSpread1 = false
          this.doms.itemBox1Dom.style.height = this.initItemBoxHeight + 'px'
          break;
        case 2:
          this.isSpread2 = false
          this.doms.itemBox2Dom.style.height = this.initItemBoxHeight + 'px'
          break;
        default:
          break;
      }
    },

    // 判断是否应该显示右侧三角
    isShowRightCaret() {
      if(!this.doms.titleDom){
        this.doms.titleDom = document.querySelector('.item-box .title')
      }
      if(!this.doms.itemBox0Dom){
        this.doms.itemBox0Dom = document.querySelector('.weifx')
      }
      if(!this.doms.itemBox1Dom){
        this.doms.itemBox1Dom = document.querySelector('.fxzhong')
      }
      if(!this.doms.itemBox2Dom){
        this.doms.itemBox2Dom = document.querySelector('.yifx')
      }
      if(!this.doms.content0Dom){
        this.doms.content0Dom = document.querySelector('.item-box #content0')
      }
      if(!this.doms.content1Dom){
        this.doms.content1Dom = document.querySelector('.item-box #content1')
      }
      if(!this.doms.content2Dom){
        this.doms.content2Dom = document.querySelector('.item-box #content2')
      }
      const itemBox0Height = this.doms.itemBox0Dom.offsetHeight
      if(this.initItemBoxHeight === 0){
        // 最初的盒高度
        this.initItemBoxHeight = itemBox0Height
      }
      const titleHeight = this.doms.titleDom.offsetHeight
      const c0Height = this.doms.content0Dom.scrollHeight
      const c1Height = this.doms.content1Dom.scrollHeight
      const c2Height = this.doms.content2Dom.scrollHeight

      if(titleHeight + c0Height > this.initItemBoxHeight ){
        this.isShowCaret[0] = true
      }
      if(titleHeight + c1Height > this.initItemBoxHeight ){
        this.isShowCaret[1] = true
      }
      if(titleHeight + c2Height > this.initItemBoxHeight ){
        this.isShowCaret[2] = true
      }
    }




  },
  async created() {
    setInterval(() => {
      this.currentTime.date = moment().format("YYYY-MM-DD");
      this.currentTime.week = moment().format("dddd");
      this.currentTime.time = moment().format("HH:mm:ss");
    }, 1000);

    // this.schoolNo = location.hostname.split('.')[0]
    this.schoolNo = this.$route.params.schoolNo
    console.log(this.schoolNo);

    await this.getDetailBySchoolNo()

    this.getListBySchoolNo()
    // 根据后台配置的时间频率，刷新列表接口
    this.myInterval = setInterval(()=>{
      this.getListBySchoolNo()
    }, this.classUpdateFrequency * 1000)

  },
  beforeDestroy() {
    clearInterval(this.myInterval)
  },
};